import "react-app-polyfill/stable";

import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "abortcontroller-polyfill/dist/abortcontroller-polyfill-only";

import "./index.scss";
import "./utils/firebase";
import App from "./App";
import { store } from "./store";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
